import { setFileList } from '../State/fileList';

export default () => async (dispatch) => {

  dispatch(setFileList([]));
  
}